import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

// Get all user groups
const getAllUserGroups = async () => {
  try {
    return await axios.get(`${API_URL}/user-groups`);
  } catch (error) {
    throw error;
  }
};

// Get single user group
  const getSingleUserGroup = async (userGroupId, offset = 0, limit = 20, search = '') => {
  try {
    return await axios.get(`${API_URL}/user-groups/${userGroupId}?offset=${offset}&limit=${limit}&search=${search}`);
  } catch (error) {
    throw error;
  }
};

// Get all users
const getAllUsers = async (offset, limit, search = '') => {
  try {
    return await axios.get(`${API_URL}/user-groups/users?offset=${offset}&limit=${limit}&search=${search}`);
  } catch (error) {
    throw error;
  }
};

/**
 * Get all userGroups by incident report
 *
 * @param {*} date: Date
 * @param {*} countries: string[]
 * @return {*}
 */
const getUserGroupsError = async (date, countries) => {
  try {
    return await axios.post(`${API_URL}/user-groups/error-group/${date}`, { countries });
  } catch (error) {
    throw error;
  }
};

// Get user's childrens
const getChildrens = async userName => {
  try {
    return await axios.get(`${API_URL}/user-groups/users/${userName}`);
  } catch (error) {
    throw error;
  }
};

// Create user group
const createUserGroup = async data => {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}/user-groups`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Update user group
const updateUserGroup = async (data, userGroupId) => {
  try {
    return await axios({
      method: 'put',
      url: `${API_URL}/user-groups/${userGroupId}`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Add users to a user group
const addUsers = async (data, userGroupId) => {
  try {
    return await axios({
      method: 'put',
      url: `${API_URL}/user-groups/${userGroupId}/add-users`,
      data
    });
  } catch (error) {
    throw error;
  }
};

// Delete user group
const deleteUserGroup = async userGroupId => {
  try {
    return await axios.delete(`${API_URL}/user-groups/${userGroupId}`);
  } catch (error) {
    throw error;
  }
};

const userGroupsApi = {};

userGroupsApi.getAllUserGroups = getAllUserGroups;
userGroupsApi.getAllUsers = getAllUsers;
userGroupsApi.getUserGroupsError = getUserGroupsError;
userGroupsApi.getChildrens = getChildrens;
userGroupsApi.getSingleUserGroup = getSingleUserGroup;
userGroupsApi.createUserGroup = createUserGroup;
userGroupsApi.updateUserGroup = updateUserGroup;
userGroupsApi.addUsers = addUsers;
userGroupsApi.deleteUserGroup = deleteUserGroup;

export default userGroupsApi;
